const BrandsTypes = {
  BRANDS_LOADING: "BRANDS_LOADING",
  GET_BRANDS_SUCCESS: "GET_BRANDS_SUCCESS",
  GET_SCROLL_BRANDS_SUCCESS: "GET_SCROLL_BRANDS_SUCCESS",
  ADD_BRANDS_SUCCESS: "ADD_BRANDS_SUCCESS",
  UPDATE_BRANDS_SUCCESS: "UPDATE_BRANDS_SUCCESS",
  DELETE_BRANDS_SUCCESS: "DELETE_BRANDS_SUCCESS",
  GET_BRANDS_DETAILS_SUCCESS: "GET_BRANDS_DETAILS_SUCCESS",
};
export default BrandsTypes;
